import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export function setId(serviceTemplate, id) {
    return _object_spread_props(_object_spread({}, serviceTemplate), {
        id
    });
}
export function applyEdit(serviceTemplate, edit) {
    const _object_spread1 = _object_spread({}, serviceTemplate, edit), { bundle, taxable } = _object_spread1, common = _object_without_properties(_object_spread1, [
        "bundle",
        "taxable"
    ]);
    return bundle ? _object_spread_props(_object_spread({}, common), {
        bundle
    }) : _object_spread_props(_object_spread({}, common), {
        taxable
    });
}
export function inheritStanfordTaxMapping(serviceTemplate) {
    return _object_spread_props(_object_spread({}, serviceTemplate), {
        integrations: serviceTemplate.integrations.inheritStanfordTaxMapping()
    });
}
